// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const ReactDOM = require('react-dom');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { InputSafe } = require('commonsComponents/inputSafe');

require('./Holders.scss');

class HoldersData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showFullName: true,
            showNameGroup: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleClickFullName = this.handleClickFullName.bind(this);
        this.handleBlurNameGroup = this.handleBlurNameGroup.bind(this);
        this.handleShowNameGroup = this.handleShowNameGroup.bind(this);
        this.handleShowFullName = this.handleShowFullName.bind(this);
        this.handleRegexOnKeyPressAndPaste = this.handleRegexOnKeyPressAndPaste.bind(this);
        this.fullNameInput = React.createRef();
        this.nameInputsWrapper = React.createRef();
    }

    componentDidUpdate() {
        const errorsState = this.props.errorsState;
        if (
            (errorsState['firstName'] ||
                errorsState['lastName'] ||
                errorsState['secondlastName']) &&
            this.state.showFullName
        ) {
            this.handleShowNameGroup();
        }

        return true;
    }

    removeFocusOnFullName() {
        const element = ReactDOM.findDOMNode(this.fullNameInput.current);

        if (!!element) {
            element.getElementsByTagName('input')[0].blur();
        }
    }

    removeFocusOnNameGroup() {
        const element = ReactDOM.findDOMNode(this.nameInputsWrapper.current);

        if (!!element) {
            const inputs = element.getElementsByTagName('input');
            Array.from(inputs).forEach(inputElement => {
                inputElement.blur();
            });
        }
    }

    handleBlur(event, prop, isChange = false) {
        const formId = this.props.formId;
        this.props.handleBlur(event, formId, prop, isChange);
    }

    handleBlurNameGroup(event, prop) {
        const formId = this.props.formId;
        const firstName = this.props.formData.firstName;
        const lastName = this.props.formData.lastName;
        const secondlastName = this.props.formData.secondlastName;

        this.props.handleBlur(event, formId, prop);

        if (
            firstName != null &&
            firstName.length > 0 &&
            (lastName != null && lastName.length > 0) &&
            (secondlastName != null && secondlastName.length > 0)
        ) {
            this.handleShowFullName();
        }
    }

    handleChange(event, prop) {
        const formId = this.props.formId;
        this.props.handleChange(event, formId, prop);
    }

    handleClickFullName() {
        this.removeFocusOnFullName();
        this.handleShowNameGroup();
    }

    handleRegexOnKeyPressAndPaste(event) {
        const { regexInputFullName } = this.props;
        const regexText = event.clipboardData
            ? event.clipboardData.getData('text/plain')
            : String.fromCharCode(event.charCode);

        if (regexInputFullName && !regexInputFullName.test(regexText) && !event.ctrlKey) {
            event.preventDefault();
        }
    }

    handleRemove() {
        const formId = this.props.formId;
        this.props.handleRemove(formId);
    }

    handleShowFullName() {
        this.setState({
            showFullName: true,
            showNameGroup: false
        });

        this.removeFocusOnNameGroup();
    }

    handleShowNameGroup() {
        this.setState({
            showFullName: false,
            showNameGroup: true
        });
    }

    render() {
        const errorsState = this.props.errorsState;
        let formId = this.props.formId;
        let idHolders = 'holder_' + formId;
        let idFirstName = 'firstname_' + formId;
        let idSecondlastName = 'secondlastname_' + formId;
        let idLastName = 'lastname_' + formId;
        let idFullName = 'fullname_' + formId;
        let idNameGroup = 'nameGroup_' + formId;
        let idIdentificationType = 'identificationtype_' + formId;
        let idIdentificationValue = 'identificationvalue_' + formId;
        let idAccountRelation = 'accountrelation_' + formId;
        let classRemoveTax = this.props.showRemove ? 'pull-right' : 'hidden';
        let showFullName = this.state.showFullName ? 'holders-form__group' : 'hidden';
        let showNameGroup = this.state.showNameGroup ? 'holders-form__group' : 'hidden';
        let fullNameValue =
            this.props.formData.firstName +
            ' ' +
            this.props.formData.lastName +
            ' ' +
            this.props.formData.secondlastName;
        let fullNameError =
            errorsState['firstName'] || errorsState['lastName'] || errorsState['secondlastName'];
        const identificationError = errorsState['identificationValue'];
        const errorMessageValidValue = formatText('contractsView-requiredFieldError');
        const errorMessageDocumentType = formatText('contractsView-documentTypeRequiredError');
        const errorMessageDocumentNumber = identificationError && formatText(identificationError);
        const errorMessageIntervenerType = formatText('contractsView-intervenerTypeRequiredError');
        const handleChange = this.handleChange;
        const handleBlur = this.handleBlur;
        const handleBlurNameGroup = this.handleBlurNameGroup;
        return (
            <div className="holders-form" id={idHolders} key={idHolders}>
                <div className="row holders-form__row">
                    <div className="col-xs-12">
                        <div className={classRemoveTax}>
                            <OKButton
                                leftIcon="icon icon-quitar"
                                modifier="ghost"
                                onClick={this.handleRemove}
                            >
                                <FormattedText
                                    value="contractsView-checkingAccountTaxationDataIndicatorTaxationRemove"
                                />
                            </OKButton>
                        </div>
                    </div>
                    <div className="col-xs-12">
                        <div className="ok-slider__text">
                            {formatText('contractsView-checkingAccountHoldersCompleteName')}
                        </div>

                        <div className={showFullName} onClick={this.handleClickFullName}>
                            <div className="full-name">
                                <InputSafe
                                    label={null}
                                    placeholder={formatText(
                                        'contractsView-checkingAccountAddHolderFullName'
                                    )}
                                    name="fullName"
                                    ref={this.fullNameInput}
                                    referenceName="fullName"
                                    type="text"
                                    value={fullNameValue}
                                    id={idFullName}
                                    errorMessage={errorMessageValidValue}
                                    errorState={fullNameError}
                                />
                            </div>
                        </div>
                        <div
                            className={showNameGroup}
                            id={idNameGroup}
                            ref={this.nameInputsWrapper}
                        >
                            <div className="holders-form__col">
                                <InputSafe
                                    label={null}
                                    placeholder={formatText(
                                        'contractsView-checkingAccountAddHolderNameTitle'
                                    )}
                                    name="firstName"
                                    onBlur={event => handleBlurNameGroup(event, 'firstName')}
                                    onChange={event => handleBlur(event, 'firstName')}
                                    onKeyPress={this.handleRegexOnKeyPressAndPaste}
                                    onPaste={this.handleRegexOnKeyPressAndPaste}
                                    referenceName="firstName"
                                    type="text"
                                    value={this.props.formData.firstName}
                                    id={idFirstName}
                                    maxLength={20}
                                    errorMessage={errorMessageValidValue}
                                    errorState={errorsState['firstName']}
                                />
                            </div>
                            <div className="holders-form__col">
                                <InputSafe
                                    label={null}
                                    placeholder={formatText(
                                        'contractsView-checkingAccountAddHolderLastName'
                                    )}
                                    name="lastName"
                                    onBlur={event => handleBlurNameGroup(event, 'lastName')}
                                    onChange={event => handleBlur(event, 'lastName')}
                                    onKeyPress={this.handleRegexOnKeyPressAndPaste}
                                    onPaste={this.handleRegexOnKeyPressAndPaste}
                                    referenceName="lastName"
                                    type="text"
                                    value={this.props.formData.lastName}
                                    id={idLastName}
                                    maxLength={30}
                                    errorMessage={errorMessageValidValue}
                                    errorState={errorsState['lastName']}
                                />
                            </div>
                            <div className="holders-form__col">
                                <InputSafe
                                    label={null}
                                    placeholder={formatText(
                                        'contractsView-checkingAccountAddHolderSecondLastName'
                                    )}
                                    name="secondlastName"
                                    onBlur={event => handleBlurNameGroup(event, 'secondlastName')}
                                    onChange={event => handleBlur(event, 'secondlastName')}
                                    onKeyPress={this.handleRegexOnKeyPressAndPaste}
                                    onPaste={this.handleRegexOnKeyPressAndPaste}
                                    referenceName="secondlastName"
                                    type="text"
                                    value={this.props.formData.secondlastName}
                                    id={idSecondlastName}
                                    maxLength={30}
                                    errorMessage={errorMessageValidValue}
                                    errorState={errorsState['secondlastName']}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row holders-form__row">
                    <div className="col-xs-12">
                        <div className="ok-slider__text">
                            {formatText('contractsView-checkingAccountHoldersIdentification')}
                        </div>

                        <div className="holders-form__group">
                            <div className="holders-form__col">
                                <OKSelect
                                    placeholder={formatText(
                                        'contractsView-checkingAccountTaxationDataIndicatorTaxationReasonPlaceholder'
                                    )}
                                    name="identificationType"
                                    searchable={true}
                                    options={this.props.identificationTypeSource}
                                    onChange={event => handleChange(event, 'identificationType')}
                                    value={this.props.formData.identificationType}
                                    id={idIdentificationType}
                                    errorMessage={errorMessageDocumentType}
                                    errorState={errorsState['identificationType']}
                                />
                            </div>
                            <div className="holders-form__col">
                                <InputSafe
                                    label={null}
                                    placeholder={formatText(
                                        'contractsView-checkingAccountAddHolderInsertDocumentNumber'
                                    )}
                                    name="identificationValue"
                                    onBlur={event => handleBlur(event, 'identificationValue')}
                                    onChange={event => handleBlur(event, 'identificationValue', true)}
                                    referenceName="identificationValue"
                                    type="text"
                                    value={this.props.formData.identificationValue}
                                    id={idIdentificationValue}
                                    errorMessage={errorMessageDocumentNumber}
                                    errorState={!!identificationError}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row holders-form__row">
                    <div className="col-xs-12">
                        <div className="ok-slider__text">
                            <FormattedText value="contractsView-checkingAccountHoldersAccountRelation" />
                            <OKTooltip
                                content="contractsView-taxationTooltipDescription"
                                offset={[0, -15]}
                            />
                        </div>
                        <div className="holders-form__group">
                            <div>
                                <OKSelect
                                    placeholder={formatText(
                                        'contractsView-checkingAccountTaxationDataIndicatorTaxationReasonPlaceholder'
                                    )}
                                    name="accountRelation"
                                    searchable={true}
                                    options={this.props.relationTypeSource}
                                    onChange={event => handleChange(event, 'accountRelation')}
                                    value={this.props.formData.accountRelation}
                                    id={idAccountRelation}
                                    errorMessage={errorMessageIntervenerType}
                                    errorState={errorsState['accountRelation']}
                                />
                                <p>
                                    {formatText('contractsView-taxationAccountTypeWarning')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

HoldersData.propTypes = {
    taxCountryOptions: PropTypes.array,
    relationTypeSource: PropTypes.array,
    identificationTypeSource: PropTypes.array,
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    handleRemove: PropTypes.func,
    formData: PropTypes.object,
    formId: PropTypes.number,
    showRemove: PropTypes.bool.isRequired,
    errorsState: PropTypes.any.isRequired,
    regexInputFullName: PropTypes.any
};

module.exports = HoldersData;
